import type { PatientCategory as PatientCategoryRecord } from '../services/httpServices/patientCategoryService';

/**
 * Human-readable label for a stored patient-category key.
 *
 * Categories live in Patients › Categories (`/patients/categories`) and the
 * patient record only stores the key (e.g. `free_campaign`). Pass the loaded
 * category list to get the exact configured label; without it the key is
 * prettified (`free_campaign` → "Free / Campaign" is not recoverable, so it
 * becomes "Free Campaign").
 */
export function patientCategoryLabel(
  key?: string | null,
  categories: PatientCategoryRecord[] = [],
): string {
  if (!key) return '—';

  const match = categories.find((category) => category.name === key);
  if (match?.label) return match.label;

  return key
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map((word) =>
      word.toLowerCase() === 'vip'
        ? 'VIP'
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(' ');
}
